module.exports = __webpack_public_path__ + "media/images/workplace/patterns/5-7c3469ea1047ba1c8405d47558808d67.png";